import { type IServer } from 'interfaces/server';
import { getWebsocketConnection } from 'services/server/websocket-connection';

/**
 * @deprecated Use `getWebsocketConnection` instead.
 */
export function getServer(): IServer {
  return getWebsocketConnection();
}
